import styled, { useTheme } from 'styled-components';
import useSupportPageController from '../../1_application/support/supportPageController';
import { Support, SupportCategory } from '../../2_domain/support/support';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import { XCenter } from '../core/components/center';
import LXPagination from '../core/pagination/lxPagination';
import { LXbody, LXbodyLong, LXh2, LXh3, LXh4 } from '../core/texts/lxText';
import { ReactComponent as Question } from '../../assets/icons/question.svg';
import LXExpandable from '../core/components/buttons/lxExpandable';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import LXSpinner from '../core/spinner/lx_spinner';
import LXError from '../core/error/lx_error';

const SupportPage = () => {
  const theme = useTheme();
  const c = useSupportPageController();

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXh2>{theme.texts.support}</LXh2>
        <SizedBox height={55}></SizedBox>
        <Row>
          <SupportCategoryList
            categories={c.categories}
            value={c.selectedCategory}
            onChange={c.setSelectedCategory}
          ></SupportCategoryList>
          <SizedBox width={24}></SizedBox>
          <Column alignItems="center">
            <SupportList
              isLoaindg={c.isLoading}
              supports={c.supports}
            ></SupportList>
            <SizedBox width={28}></SizedBox>
            <LXPagination
              total={c.pageResult.totalElements}
              pageSize={c.pageSize}
              current={c.pageResult.pageNumber}
              onChange={c.setPageNumber}
            ></LXPagination>
            <SizedBox height={40}></SizedBox>
            <StillQuestion></StillQuestion>
          </Column>
        </Row>
      </Column>
    </XCenter>
  );
};

interface SupportCategoryListProps {
  categories: SupportCategory[];
  value: SupportCategory;
  onChange: (data: SupportCategory) => void;
}

const SupportCategoryContainer = styled.div`
  cursor: pointer;
  padding-bottom: 16px;
`;

const SupportCategoryList = (props: SupportCategoryListProps) => {
  const theme = useTheme();

  const items = props.categories.map((category, idx) => {
    const isSelected = category === props.value;
    return (
      <SupportCategoryContainer
        key={idx}
        onClick={() => props.onChange(category)}
      >
        <LXh4
          color={isSelected ? theme.colors.primary500 : theme.colors.caption}
        >
          {category.label}
        </LXh4>
      </SupportCategoryContainer>
    );
  });

  return <Column width="140px">{items}</Column>;
};

interface SupportListProps {
  supports: Support[];
  isLoaindg?: boolean;
}

const Separator = styled.div`
  margin: 20px 0px;
  height: 1px;
  background-color: ${(props) => props.theme.colors.grayLine};
`;

const BodyPadding = styled.div`
  padding-top: 12px;
`;

const SupportList = (props: SupportListProps) => {
  const headerBuilder = (support: Support, idx: number) => {
    return <LXh4 width="748px">{support.title}</LXh4>;
  };

  const contentBuilder = (support: Support, idx: number) => {
    return (
      <BodyPadding>
        <LXbodyLong>{support.content}</LXbodyLong>
      </BodyPadding>
    );
  };

  const panelBuilder = (support: Support, idx: number) => {
    return (
      <CollapsePanel key={idx} header={headerBuilder(support, idx)}>
        {contentBuilder(support, idx)}
      </CollapsePanel>
    );
  };

  return (
    <LXExpandable<Support>
      width={796}
      datas={props.supports}
      panelBuilder={panelBuilder}
      separator={<Separator></Separator>}
      isLoading={props.isLoaindg}
    ></LXExpandable>
  );
};

const StillQuestionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 12px;
`;

const StillQuestion = () => {
  const theme = useTheme();
  return (
    <StillQuestionContainer>
      <Column alignItems="center">
        <SizedBox height={30}></SizedBox>
        <Question></Question>
        <SizedBox height={10}></SizedBox>
        <LXh3>{theme.texts.stillHaveQuestions}</LXh3>
        <SizedBox height={8}></SizedBox>
        <LXbody
          color={theme.colors.caption}
        >{`${theme.texts.cantFindTheAnswerYouReLookingFor} ${theme.texts.SendUsAnEmailAndWellGetAResponse}`}</LXbody>
        <SizedBox height={4}></SizedBox>
        <LXbody
          whiteSpace="pre-line"
          overflow="visible"
          textAlign="center"
          color={theme.colors.primary500}
        >
          {`${theme.texts.slxEmail}\n${theme.texts.slxPhone}`}
        </LXbody>
        <SizedBox height={30}></SizedBox>
      </Column>
    </StillQuestionContainer>
  );
};

export default withAsync({
  child: SupportPage,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
